import { Helmet } from 'react-helmet-async';

const Collections = () => {
  return (
    <>
      <Helmet>
        <title>Collections | Panchali Boutique</title>
      </Helmet>
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Our Collections</h1>
        {/* Add your collections content here */}
      </div>
    </>
  );
};

export default Collections;